import { Anchor, Card } from '@zenid/web';
import { css } from '../../../../../styled-system/css';
import { flex } from '../../../../../styled-system/patterns';

export function EmailChangeComplete() {
  return (
    <Card
      className={css({
        width: '343px',
        backgroundColor: '{colors.background.white}',
        padding: '{spacing.40} {spacing.20}',
        sm: { width: '400px', padding: '{spacing.40}' },
      })}
    >
      <div
        className={flex({
          flexDirection: 'column',
          justifyContent: 'center',
        })}
      >
        <div className={flex({ justifyContent: 'center', paddingBottom: '{spacing.24}' })}>
          <img
            width="88px"
            src={`${import.meta.env.VITE_ASSETS_URL}/assets/images/change_success.png`}
            alt="メール送信成功"
          />
        </div>
        <div
          className={flex({
            flexDirection: 'column',
            gap: '{spacing.16}',
          })}
        >
          <h1
            className={css({
              textStyle: 'headding.l',
              textAlign: 'center',
              color: '{colors.text.main}',
              wordBreak: 'keep-all',
            })}
          >
            メールアドレスが変更されました
          </h1>
          <p className={css({ textStyle: 'body.m.default', color: '{colors.text.sub}', textAlign: 'center' })}>
            メールアドレスの変更が完了しました
          </p>
        </div>
      </div>
      <Anchor
        variant="button"
        href="/home"
        className={css({ marginTop: '{spacing.24}' })}
        color="primary"
        size="l"
        stretch="container"
      >
        戻る
      </Anchor>
    </Card>
  );
}
